import { useEffect } from 'react'
import { Route, Redirect, withRouter, RouteProps, Switch, useHistory } from 'react-router-dom'
import 'moment/locale/vi'
import { observer } from 'mobx-react-lite'
import { useStore } from 'src/hooks'
import { LOCAL_STORAGE, ROLE, ROLE_ACCOUNT, STATUS_LOGIN } from './helpers/constants'
import { Loading } from 'src/common'
import LayoutUser from 'src/screens/layouts/containers/LayoutUser'
import LoginScreen from 'src/screens/authenticate/LoginScreen'
import ForgotPasswordScreen from 'src/screens/authenticate/ForgotPasswordScreen'
import VerifyEmailScreen from 'src/screens/verify-email/VerifyEmailScreen'
import ResendEmailScreen from 'src/screens/verify-email/ResendEmailScreen'
import LayoutAdmin from 'src/screens/layouts/containers/LayoutAdmin'
import { isEmpty, noop } from 'lodash'
import ResetPasswordScreen from 'src/screens/authenticate/ResetPasswordScreen'
import { LoadingProvider, createLoadingRef } from './common/components/LoadingContainer'
import TermsAndServicesPage from './screens/terms-and-services/TermsAndServicesPage'
import SupportPage from './screens/support/SupportPage'
import AboutUsPage from './screens/about-us-page/AboutUsPage'
import DeleteAccount from './screens/deleteAccount/DeleteAccount'
import LayoutSale from './screens/layouts/containers/LayoutSale'

// Creamos un objeto global para acceder al loader desde cualquier lugar
// export const globalLoader = createLoadingRef()
interface ProtectedRouteProps extends RouteProps {
   // tslint:disable-next-line:no-any
   component: any
   isSignedIn: number
   role?: string
   currentRole: string
}

const App = observer((props) => {
   const AuthStore: any = useStore('AuthStore')
   const role: any = AuthStore.data_role
   const history = useHistory()

   useEffect(() => {
      if (process.env.REACT_APP_ENV !== 'DEV') {
         // eslint-disable-next-line no-console
         console.log = noop
         // eslint-disable-next-line no-console
         console.warn = noop
         // eslint-disable-next-line no-console
         console.error = noop
      }
      handle_fetchData()
      // eslint-disable-next-line react-hooks/exhaustive-deps
      // AuthStore.isLogin = STATUS_LOGIN.LOGIN_SUCCESS;
   }, [])

   const getCommonData = async () => {
      // if (role !== ROLE.ACCOUNTANT && role !== ROLE.SUPPORTER) {
      //    await CommonConfigStore.getConfigCommon()
      // }
   }

   useEffect(() => {
      if (AuthStore.isLogin === STATUS_LOGIN.LOGIN_SUCCESS) {
         AuthStore.action_getRole(history).then((res: any) => {
            if (!res) {
               // JobsStore.resetJobs()
               return
            }
            // getCommonData()
         })
         // getCommonData()
      }
   }, [AuthStore.isLogin, history])

   useEffect(() => {
      window.addEventListener('resize', () => {
         AuthStore.width_screen = window.innerWidth
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const handle_fetchData = async () => {
      // if (!CommonConfigStore.linkSupport) {
      //    CommonConfigStore.getListSupport()
      // }
      const dataAuth = await localStorage.getItem(LOCAL_STORAGE.DATA_AUTH)
      console.log('dataAuth appp', dataAuth)

      if (!isEmpty(dataAuth) && dataAuth !== '{}') {
         AuthStore.isLogin = STATUS_LOGIN.LOGIN_SUCCESS
      } else {
         AuthStore.isLogin = STATUS_LOGIN.NOT_LOGIN
      }
   }

   const isAdminRoute = () => {
      if (role === ROLE_ACCOUNT.ADMIN) return true
      return false
   }
   const isSaleRoute = () => {
      if (role === ROLE_ACCOUNT.SALE) return true
      return false
   }
   return (
      <>
         <LoadingProvider>
            <Switch>
               <Route
                  exact
                  path="/signin"
                  component={LoginScreen}
                  render={() => {
                     return AuthStore.isLogin === STATUS_LOGIN.LOGIN_SUCCESS ? (
                        <Redirect to="/" />
                     ) : (
                        <Redirect to="/signin" />
                     )
                  }}
               />
               <Route exact path="/delete-account" component={DeleteAccount} />
               <Route exact path="/terms-and-services" component={TermsAndServicesPage} />
               <Route exact path="/support" component={SupportPage} />
               <Route exact path="/about-us" component={AboutUsPage} />
               <Route exact path="/forgot-password" component={ForgotPasswordScreen} />
               <Route exact path="/reset-password" component={ResetPasswordScreen} />
               <Route exact path="/verify-email" component={VerifyEmailScreen} />
               <Route exact path="/resend-verify-email" component={ResendEmailScreen} />

               <Switch>
                  {isAdminRoute() ? (
                     <ProtectedRoute
                        isSignedIn={AuthStore.isLogin}
                        path="/"
                        component={LayoutAdmin}
                        role={ROLE_ACCOUNT.ADMIN}
                        currentRole={role}
                     />
                  ) : isSaleRoute() ? (
                     <ProtectedRoute
                        isSignedIn={AuthStore.isLogin}
                        path="/"
                        component={LayoutSale}
                        role={ROLE_ACCOUNT.SALE}
                        currentRole={role}
                     />
                  ) : (
                     <ProtectedRoute
                        isSignedIn={AuthStore.isLogin}
                        component={LayoutUser}
                        path="/"
                        role={ROLE_ACCOUNT.SALE}
                        currentRole={role}
                     />
                  )}
               </Switch>

               <Route path="*" component={LoginScreen} />
            </Switch>
            {/* <globalLoader.LoadingComponent /> */}
         </LoadingProvider>
      </>
   )
})

const ProtectedRoute = (props: ProtectedRouteProps) => {
   const { component: Component, isSignedIn, role, currentRole, ...rest } = props
   const isAuthenticate = () => {
      // if (currentRole !== role) return false
      return true
   }
   return (
      <Route
         {...rest}
         render={(routeProps) => {
            if (isSignedIn === STATUS_LOGIN.WAIT_LOGIN) {
               return <Loading isLoading={true} />
            } else if (isSignedIn === STATUS_LOGIN.LOGIN_SUCCESS) {
               if (isAuthenticate()) return <Component {...routeProps} />
               else return <></>
            } else {
               return (
                  <Redirect
                     to={{
                        pathname: '/signin',
                        state: { from: routeProps.location }
                     }}
                  />
               )
            }
         }}
      />
   )
}

export default withRouter(App)
